import { InfoIcon } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export interface ErrorInfo {
  message: string;
  details?: string;
}

interface ErrorInfoDisplayProps {
  errorInfo: ErrorInfo;
}

export const ErrorInfoDisplay = ({ errorInfo }: ErrorInfoDisplayProps) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <div className="mt-3 flex items-center gap-2">
        {errorInfo.details && (
          <Button
            variant="destructive"
            size="icon-md"
            onClick={() => setDialogOpen(true)}
            aria-label="View error details"
          >
            <InfoIcon className="h-4 w-4" />
          </Button>
        )}
        <p className="text-sm text-red-600">{errorInfo.message}</p>
      </div>
      {errorInfo.details && (
        <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Error Details</DialogTitle>
            </DialogHeader>
            <pre className="text-xs text-gray-500 overflow-auto max-h-[60vh] p-3 bg-gray-50 rounded-md">
              {errorInfo.details}
            </pre>
            <div className="flex justify-end mt-4">
              <Button onClick={() => setDialogOpen(false)}>Close</Button>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};
